export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00683.34e27359.png";